// extracted by mini-css-extract-plugin
module.exports = {"Divider":"Divider_Divider__Vb8bT","icon":"Divider_icon__aVEw_"};